import type { Namespace } from '../types';

// DE drafted — queued for native review. Device catalog (R-097/D-090): per-channel
// sensor/actuator metadata. `code` mirrors the wc_events wire channel (invariant).
export const deviceCatalog = {
  title: { de: 'Gerätekatalog', en: 'Device Catalog' },
  desc: {
    de: 'Metadaten für Sensoren & Aktoren — Modell, Einheit, Bereich, Kapazität, Kalibrierung. Wird an die Standorte repliziert.',
    en: 'Metadata for sensors & actuators — model, unit, range, capacity, calibration. Replicated down to the sites.',
  },

  tabSensors: { de: 'Sensoren', en: 'Sensors' },
  tabActuators: { de: 'Aktoren', en: 'Actuators' },

  colCode: { de: 'Code', en: 'Code' },
  colModel: { de: 'Modell', en: 'Model' },
  colName: { de: 'Name', en: 'Name' },
  colUnit: { de: 'Einheit', en: 'Unit' },
  colRange: { de: 'Bereich', en: 'Range' },
  colCapacity: { de: 'Kapazität', en: 'Capacity' },
  colActive: { de: 'Aktiv', en: 'Active' },
  inactive: { de: 'inaktiv', en: 'inactive' },

  fieldMin: { de: 'Minimalwert', en: 'Min value' },
  fieldMax: { de: 'Maximalwert', en: 'Max value' },
  fieldCapacityUnit: { de: 'Kapazitätseinheit', en: 'Capacity unit' },
  fieldCalibration: { de: 'Kalibrierung (JSON)', en: 'Calibration (JSON)' },
  fieldParameters: { de: 'Parameter (JSON)', en: 'Parameters (JSON)' },

  colActions: { de: 'Aktionen', en: 'Actions' },
  filterStatus: { de: 'Alle Status', en: 'All statuses' },
  noMatch: { de: 'Keine Einträge passen zu diesem Filter', en: 'No entries match this filter' },
  add: { de: 'Hinzufügen', en: 'Add' },
  // The primary action names what it adds — it follows the active tab.
  addSensor: { de: 'Sensor hinzufügen', en: 'Add Sensor' },
  addActuator: { de: 'Aktor hinzufügen', en: 'Add Actuator' },
  newSensor: { de: 'Neuer Sensor', en: 'New Sensor' },
  newActuator: { de: 'Neuer Aktor', en: 'New Actuator' },
  editSensor: { de: 'Sensor bearbeiten', en: 'Edit sensor' },
  editActuator: { de: 'Aktor bearbeiten', en: 'Edit actuator' },
  phCode: { de: 'z. B. air_temp', en: 'e.g. air_temp' },
  phModel: { de: 'z. B. SHT31', en: 'e.g. SHT31' },
  phName: { de: 'z. B. Lufttemperatur', en: 'e.g. Air temperature' },
  phUnit: { de: 'z. B. °C', en: 'e.g. °C' },
  phMin: { de: 'z. B. -40', en: 'e.g. -40' },
  phMax: { de: 'z. B. 125', en: 'e.g. 125' },
  phCapacity: { de: 'z. B. 20', en: 'e.g. 20' },
  phCapacityUnit: { de: 'z. B. L/h', en: 'e.g. L/h' },
  phCalibration: { de: '{"offset": 0}', en: '{"offset": 0}' },
  phParameters: { de: '{"i2c_addr": "0x44"}', en: '{"i2c_addr": "0x44"}' },
  jsonHint: { de: 'JSON-Objekt; leer bedeutet {}', en: 'A JSON object; empty means {}' },
  newEntry: { de: 'Neuer Eintrag', en: 'New entry' },
  editEntry: { de: 'Eintrag bearbeiten', en: 'Edit entry' },

  deleteTitle: { de: '{code} löschen?', en: 'Delete {code}?' },
  deleteMsg: {
    de: 'Der Katalogeintrag wird bei der nächsten Replikation von allen Standorten entfernt.',
    en: 'The catalog entry is removed from every site on the next replication.',
  },
  toastSaved: { de: '{code} gespeichert', en: '{code} saved' },
  toastDeleted: { de: '{code} gelöscht', en: '{code} deleted' },
  badJson: {
    de: 'Kalibrierung/Parameter müssen gültiges JSON sein',
    en: 'Calibration/parameters must be valid JSON',
  },

  loadError: { de: 'Gerätekatalog konnte nicht geladen werden', en: "Couldn't load device catalog" },
  emptyTitle: { de: 'Noch keine Einträge', en: 'No entries yet' },
  emptyMsg: {
    de: 'Legen Sie den Metadaten-Eintrag für einen Sensor oder Aktor an.',
    en: 'Create the metadata entry for a sensor or actuator.',
  },
} as const satisfies Namespace;
